export default class Billing {
    constructor() {
        this.id;
        this.patientId;
        this.providerId;
        this.discipline;
        this.createdByUserId;
        this.isDeleted;
        this.createdAt;
        this.patient;
        this.billingItems = [];
        this.accountId;
        this.convertToAccount;
        this.invoiceFileId;
    }
  
    set(setEntity) {
      this.id = setEntity.id;
      this.patientId = setEntity.patientId;
      this.providerId = setEntity.providerId;
      this.discipline = setEntity.discipline;
      this.createdByUserId = setEntity.createdByUserId;
      this.isDeleted = setEntity.isDeleted;
      this.createdAt = setEntity.createdAt;
      this.patient = setEntity.patient;
      this.billingItems = setEntity.billingItems ? setEntity.billingItems : [];
      this.accountId = setEntity.accountId;
      this.convertToAccount = setEntity.convertToAccount;
      this.invoiceFileId = setEntity.invoiceFileId;

      return this;
    }
  }